(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/package-huxflux-button.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/package-huxflux-button.js');

'use strict';

svs.numbergames.game.views.PackageHuxfluxButton = Marionette.View.extend({
  ui: {
    huxfluxBtn: '.js-huxflux-btn'
  },
  triggers: {
    'click @ui.huxfluxBtn': 'huxfluxRows'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }, svs.numbergames.accessibility.behaviors.UIFocusDisable],
  radioEvents: {
    'package:huxflux:started': 'huxfluxStarted',
    'package:huxflux:ended': 'huxfluxEnded'
  },
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "package-rows-buttons package-rows-buttons-".concat(brandingSuffix);
  },
  template: data => svs.numbergames.game.templates.package_huxflux_button(data),
  templateContext() {
    return {
      invertedButton: !svs.numbergames.productMapping.isKeno(this.model.get('productId')) && !svs.numbergames.productMapping.isEurojackpot(this.model.get('productId')),
      transparentButton: !svs.numbergames.productMapping.isEurojackpot(this.model.get('productId'))
    };
  },
  huxfluxStarted() {
    this.trigger('disableUI', this.getUI('huxfluxBtn'));
  },
  huxfluxEnded() {
    this.trigger('enableUI', this.getUI('huxfluxBtn'));
  },
  onHuxfluxRows() {
    this.model.get('boards').huxfluxAll();
    if (this.model.get('hasJoker')) this.model.set({
      jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow()
    });
  }
});

 })(window);